module.exports = __webpack_public_path__ + "img/sku-guide-br.da53584.jpg";